import React, { useState, useRef, useEffect, useCallback } from "react";
import EditInput from "./edit-input";
import "./title-editor.scss";
import TitleState from "./title-state";

export default function TitleEditor(props) {
  const { placeHolderValue, titleState, onTitleChange } = props;
  const [inputValue, setInputValue] = useState(placeHolderValue);
  const [editMode, setEditMode] = useState(false);
  const [editorPosition, setEditorPosition] = useState(null);
  const titleRef = useRef(null);

  useEffect(() => {
    if (titleState.getSource() === "broadcast") {
      setInputValue(titleState.getValue());
    }
  }, [titleState, setInputValue, editMode, setEditMode]);

  const onMouseClicked = (evt) => {
    if (!editMode) {
      evt.preventDefault();
      setEditorPosition(getPosition(evt.target));
      setEditMode(true);
    }
  };

  useEffect(() => {
    if (titleRef.current) {
      setEditorPosition(getPosition(titleRef.current));
    }
  }, []);

  const getPosition = (element) => {
    const currentPosition = element.getBoundingClientRect();
    return {
      top: currentPosition.top.toFixed(0) + "px",
      left: currentPosition.left.toFixed(0) + "px",
      width: currentPosition.width.toFixed(0) + "px",
      height: currentPosition.height.toFixed(0) + "px",
    };
  };

  const onMouseEnter = (evt) => {
    evt.target.style.backgroundColor = "#eeeeee";
  };

  const onMouseLeave = (evt) => {
    evt.target.style.backgroundColor = "inherit";
  };

  const onInputChange = useCallback(
    (val) => {
      setInputValue(val);
      if (onTitleChange)
        onTitleChange(
          TitleState.set(titleState, {
            source: "user",
            value: val,
            editMode: true,
          })
        );
    },
    [onTitleChange, titleState]
  );

  const onEditCompleted = (val) => {
    setEditMode(false);
    if (onTitleChange)
      onTitleChange(
        TitleState.set(titleState, {
          source: "user",
          value: val,
          editMode: false,
        })
      );
    if (titleRef.current) {
      setEditorPosition(getPosition(titleRef.current));
    }
  };

  return (
    <div onClick={onMouseClicked} ref={titleRef} className="title-container">
      {!editMode ? (
        <div
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className="title__readview title__readview--color"
        >
          {inputValue}
        </div>
      ) : (
        <EditInput
          inputValue={inputValue}
          onInputChange={onInputChange}
          onEditCompleted={onEditCompleted}
          editorPosition={editorPosition}
        />
      )}
    </div>
  );
}
